(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-charity-payout/assets/react/charity-payout-page.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-charity-payout/assets/react/charity-payout-page.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useCallback = _React.useCallback;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_charity_payout.react.components,
  CharityPayoutHeader = _svs$lyckoplatsen$com.CharityPayoutHeader,
  CharityPayoutChartContainer = _svs$lyckoplatsen$com.CharityPayoutChartContainer,
  CharityPeppText = _svs$lyckoplatsen$com.CharityPeppText,
  CharityCards = _svs$lyckoplatsen$com.CharityCards;
const PAYOUT_KEYS = svs.lyckoplatsen.components.shared_constants.CONSTANTS.PAYOUT_KEYS;
const CharityPayoutPage = () => {
  const _useState = useState(PAYOUT_KEYS.LATEST_DRAW),
    _useState2 = _slicedToArray(_useState, 2),
    payoutKey = _useState2[0],
    setPayoutKey = _useState2[1];
  const handlePayoutKeyChange = useCallback(key => {
    setPayoutKey(key);
  }, []);
  return React.createElement("div", {
    className: "u-flex-grow-1 bg-lyckoplatsen-500"
  }, React.createElement(CharityPayoutHeader, null), React.createElement(CharityPayoutChartContainer, {
    payoutKey: payoutKey,
    handlePayoutKeyChange: handlePayoutKeyChange
  }), React.createElement(CharityPeppText, null), React.createElement(CharityCards, {
    payoutKey: payoutKey
  }));
};
Object.assign(svs.lyckoplatsen.components.page_charity_payout.react, {
  CharityPayoutPage
});

 })(window);